import countriesReducer, { type CountryState, type Country } from "./countriesReducer";

export type { CountryState, Country };
export default countriesReducer;
